/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_4_DescInputs */

const en_vc_ft_4_desc = /** @type {(inputs: Vc_Ft_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach art to the grid's planes and it stays editable in perspective, ready for packaging and city scenes.`)
};

const zh_vc_ft_4_desc = /** @type {(inputs: Vc_Ft_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把图稿贴到透视平面上，依然可以在透视中编辑，适合包装和城市场景。`)
};

/**
* | output |
* | --- |
* | "Attach art to the grid's planes and it stays editable in perspective, ready for packaging and city scenes." |
*
* @param {Vc_Ft_4_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_4_desc = /** @type {((inputs?: Vc_Ft_4_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_4_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_4_desc(inputs)
	return zh_vc_ft_4_desc(inputs)
});
export { vc_ft_4_desc as "vc.ft.4.desc" }